(function () {
  'use strict';

  if (window.__arsheJudgeMeMobileFixV4) return;
  window.__arsheJudgeMeMobileFixV4 = true;

  var UI = ['.arshe-product-sticky','.arshe-mobile-bottom-nav','.luxe-mobile-cart','.arshe-scent-finder__fab','.arshe-scent-finder__backdrop','.arshe-scent-finder__panel'];
  var proxy = null;
  var nativeAction = null;
  var liveRoot = null;
  var raf = 0;

  function txt(el) {
    return ((el && (el.innerText || el.textContent || el.value || el.getAttribute && el.getAttribute('aria-label'))) || '').replace(/\s+/g,' ').trim();
  }

  function visible(el) {
    if (!el || !el.isConnected) return false;
    var s = getComputedStyle(el), r = el.getBoundingClientRect();
    return s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity || '1') > 0 && r.width > 0 && r.height > 0;
  }

  function visibleReviewModal() {
    var selectors = ['.jm-mfp-wrap','.jdgm-write-review-modal','.jdgm-modal','.jdgm-popup'];
    for (var i=0;i<selectors.length;i++) {
      var nodes=document.querySelectorAll(selectors[i]);
      for (var j=0;j<nodes.length;j++) {
        if (visible(nodes[j])) return nodes[j];
      }
    }
    return null;
  }

  function reviewTextarea(modal) {
    if (!modal) return null;
    var list = modal.querySelectorAll('textarea');
    for (var i=0;i<list.length;i++) {
      var el=list[i];
      var p=(el.getAttribute('placeholder')||'').toLowerCase();
      var a=(el.getAttribute('aria-label')||'').toLowerCase();
      if (visible(el) && (p.indexOf('start writing')>-1 || p.indexOf('review')>-1 || a.indexOf('review')>-1)) return el;
    }
    return null;
  }

  function findRoot(field) {
    if (!field) return null;
    var node=field;
    for (var i=0; node && i<10; i++, node=node.parentElement) {
      var t=txt(node).toLowerCase();
      if ((t.indexOf('terms and conditions')>-1 || t.indexOf('privacy policy')>-1 || t.indexOf("we'll only contact you")>-1) && node.querySelectorAll('button,input,[role="button"],a').length) return node;
    }
    return field.closest('form') || field.parentElement;
  }

  function findNativeAction(root) {
    if (!root) return null;
    var els=root.querySelectorAll('button,input[type="submit"],input[type="button"],[role="button"],a');
    var fallback=null;
    for (var i=0;i<els.length;i++) {
      var el=els[i], t=txt(el).toLowerCase();
      if (/^(next|continue|submit|submit review|send review)$/.test(t)) return el;
      if (!fallback && el.matches('button[type="submit"],input[type="submit"]')) fallback=el;
    }
    return fallback;
  }

  function hideStoreUI(on) {
    document.documentElement.classList.toggle('arshe-judgeme-review-open',on);
    document.body.classList.toggle('arshe-judgeme-review-open',on);
    UI.forEach(function(sel){ document.querySelectorAll(sel).forEach(function(el){
      if(on){ if(!el.hasAttribute('data-jm-old-display')) el.setAttribute('data-jm-old-display',el.style.display||''); el.style.setProperty('display','none','important'); }
      else if(el.hasAttribute('data-jm-old-display')){ var old=el.getAttribute('data-jm-old-display'); el.style.removeProperty('display'); if(old) el.style.display=old; el.removeAttribute('data-jm-old-display'); }
    }); });
  }

  function removeProxy(){ if(proxy){ proxy.remove(); proxy=null; } nativeAction=null; liveRoot=null; }

  function ensureProxy(action) {
    if (!action) { if(proxy) proxy.style.display='none'; return; }
    nativeAction=action;
    if (!proxy) {
      proxy=document.createElement('button');
      proxy.type='button';
      proxy.className='arshe-jm-mobile-next';
      proxy.addEventListener('click',function(e){
        e.preventDefault();
        if(!nativeAction || !nativeAction.isConnected) return;
        nativeAction.click();
        setTimeout(scan,80); setTimeout(scan,300);
      });
      document.body.appendChild(proxy);
    }
    proxy.textContent = /submit/i.test(txt(action)) ? 'SUBMIT REVIEW' : 'NEXT';
    proxy.style.display='flex';
  }

  function compactExactForm(field, root) {
    field.classList.add('arshe-jm-review-textarea');
    if(root) root.classList.add('arshe-jm-live-form');

    // Direct inline overrides are intentional: Judge.me's new flow does not
    // use the legacy .jdgm-form wrapper, so legacy descendant CSS misses it.
    field.style.setProperty('height','150px','important');
    field.style.setProperty('min-height','150px','important');
    field.style.setProperty('max-height','150px','important');
    field.style.setProperty('width','100%','important');
    field.style.setProperty('box-sizing','border-box','important');
    field.style.setProperty('resize','none','important');
  }

  function scan(){
    raf=0;
    var modal=visibleReviewModal();
    var field=reviewTextarea(modal);
    if(!modal || !field){ hideStoreUI(false); removeProxy(); return; }

    var root=findRoot(field);
    liveRoot=root;
    hideStoreUI(true);
    compactExactForm(field,root);

    var action=findNativeAction(root);
    if(action){
      action.classList.add('arshe-jm-native-action');
      action.removeAttribute('hidden'); action.removeAttribute('aria-hidden');
      action.style.setProperty('visibility','visible','important');
      action.style.setProperty('opacity','1','important');
      action.style.setProperty('pointer-events','auto','important');
      ensureProxy(action);
    } else ensureProxy(null);
  }

  function queue(){ if(!raf) raf=requestAnimationFrame(scan); }

  var obs=new MutationObserver(queue);
  function start(){
    obs.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','hidden','aria-hidden']});
    document.addEventListener('input',queue,true);
    document.addEventListener('click',function(){setTimeout(queue,0);setTimeout(queue,100);setTimeout(queue,400);},true);
    window.addEventListener('resize',queue,{passive:true});
    scan(); setTimeout(scan,500); setTimeout(scan,1500);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
